module.exports = __webpack_public_path__ + "img/03_cg.0e1a2216.png";